// @flow
import React from 'react';
import { connect } from 'react-redux';
// Selectors
import {
  editableInformationSelector,
  validatingUserLoadingSelector,
  editingUserInformationLoadingSelector,
  updateInformationErrorsSelector,
} from '../selectors';

import { updateInformation } from '../actions';

// Components
import MyAccountPageContainer from '../components/myAccount/MyAccountPageContainer';
import MyAccountInformation from '../components/myAccount/MyAccountInformation';
// Styles
import './MyAccountInformationPage.css';

// Types

type Props = {
  information: {
    firstName: string,
    lastName: string,
    cpf: string,
    email: string,
    phone: string,
  },
  loading: boolean,
  editingLoading: boolean,
  serverErrors: any,
  onSubmitUpdate: (
    firstName: string,
    lastName: string,
    cpf: string,
    email: string,
    phone: string,
  ) => void,
};

const MyAccountInformationPage = (props: Props) => {
  return (
    <MyAccountPageContainer>
      <MyAccountInformation
        information={props.information}
        loading={props.loading}
        editingLoading={props.editingLoading}
        serverErrors={props.serverErrors}
        onSubmitUpdate={props.onSubmitUpdate}
      />
    </MyAccountPageContainer>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    information: editableInformationSelector(state),
    loading: validatingUserLoadingSelector(state),
    editingLoading: editingUserInformationLoadingSelector(state),
    serverErrors: updateInformationErrorsSelector(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps) => {
  return {
    onSubmitUpdate: (firstName, lastName, cpf, email, phone) => {
      dispatch(updateInformation(firstName, lastName, cpf, email, phone));
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(MyAccountInformationPage);
